const state = {
  bottomSheet: null,
  bottomSheetHeight: null,
  hasHistoryEntry: false
};

const mutations = {
  SET_BOTTOM_SHEET(state, bottomSheet) {
    state.bottomSheet = bottomSheet;
  },
  SET_BOTTOM_SHEET_HEIGHT(state, height) {
    state.bottomSheetHeight = height;
  },
  SET_HAS_HISTORY_ENTRY(state, hasHistoryEntry) {
    state.hasHistoryEntry = hasHistoryEntry;
  }
};

const actions = {
  openBottomSheet({ commit }, { component, props = {}, useBackgroundBlur }) {
    commit('SET_BOTTOM_SHEET', { component, props, useBackgroundBlur });
  },
  closeBottomSheet({ commit }) {
    commit('SET_BOTTOM_SHEET', null);
    commit('SET_BOTTOM_SHEET_HEIGHT', null);
  },
  setHasHistoryEntry({ commit }, hasHistoryEntry) {
    commit('SET_HAS_HISTORY_ENTRY', hasHistoryEntry);
  }
};

export default { namespaced: true, state, mutations, actions };
